import script from "./scoreShop.vue?vue&type=script&setup=true&lang=js"
export * from "./scoreShop.vue?vue&type=script&setup=true&lang=js"

import "./scoreShop.vue?vue&type=style&index=0&id=71956244&lang=less&scoped=true"

import exportComponent from "/data/jenkins_home/workspace/prod-AI-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71956244"]])

export default __exports__